import { put, call, takeLatest, select } from 'redux-saga/effects';
import { GET_HISTORICAL_REQUEST, getHistoricalSuccess, getHistoricalFailure } from '../actions/historical';
import { getHistorical } from '../services/historical';
import { showGlobalError } from '../../app/actions/app';
import { accessTokenSelector } from '../../auth/selectors/token';
import { statusesSelector } from '../selectors/statuses';

export const getHistoricalWorker = function* ({ payload: { ticket_id, filters = {}, ticketType = "installations" } = {} } = {}) {
    try {
        const token = yield select(accessTokenSelector);

        const {
            data: { history }
        } = yield call(getHistorical, ticket_id, filters, token);

        const { statuses } = yield select(statusesSelector);

        yield put(getHistoricalSuccess(history, statuses));
    } catch (err) {
        yield put(getHistoricalFailure(err));
        yield put(showGlobalError(true, err));
    }
};

export default [takeLatest(GET_HISTORICAL_REQUEST, getHistoricalWorker)];
